<template>
  <stats-card :title="figures[figure].title"
              :type="figures[figure].gradient"
              :sub-title="value.toString()"
              :icon="figures[figure].icon"
              class="mb-4 mb-xl-0"
  >

    <template slot="header">
      <base-dropdown id="stat-card-dropdown">
        <div slot="title">
          <h5 class="card-title text-uppercase text-muted mb-0">{{figures[figure].title}}</h5>
        </div>
        <div>
          <span class="dropdown-item" v-for="(item,i) in figures" :key="item.title+i" v-on:click="figure = item.id">{{ item.title }}</span>
        </div>
      </base-dropdown>
      <div>
        <span class="h2 font-weight-bold mb-0" >{{value.toString()}}</span>
      </div>

    </template>
    <template slot="footer">
      <span class="text-info mr-2"><!--<i class="fa fa-arrow-up"></i> -->{{ value2.toString() }}</span>
      <span class="text-nowrap">{{ figures[figure].title }} insgesamt</span>
    </template>
  </stats-card>
</template>
<script>
export default {
  name: 'stats-card-customizable',
  props: {
    figure: {
      type: Number,
      default: 0
    },
    customer: {
      type: Object
    },
    location: {
      type: Object
    },
    from: {
      type: String
    },
    to: {
      type: String
    },
  },
  data() {
    return {
      figures: [
        {id: 0, title: 'Sperrabfragen', slug: 'player_request', icon: 'ni ni-chart-bar-32', gradient: 'gradient-red'},
        {id: 1, title: 'Neue Standorte', slug: 'location', icon: 'ni ni-pin-3', gradient: 'gradient-blue'},
        {id: 2, title: 'Sperranträge', slug: 'player_lock_request', icon: 'ni ni-umbrella-13', gradient: 'gradient-info'},
        {id: 3, title: 'Aktive Benutzer', slug: 'user', icon: 'ni ni-single-02', gradient: 'gradient-blue'},
        {id: 4, title: 'Schutzmaßnahmen', slug: 'activity', icon: 'fas fa-tasks', gradient: 'gradient-green'},
        {id: 5, title: 'Erledigte Aufgaben', slug: 'task', icon: 'ni ni-check-bold', gradient: 'gradient-green'}
      ],
      value: 0,
      value2: 0,
      timer: null
    }
  },
  created() {
    this.init();
  },
  watch: {
    figure: function () {
      this.init()
    },
    location: function () {
      this.init()
    },
    customer: function () {
      this.init()
    },
    from: function () {
      this.init()
    },
    to: function () {
      this.init()
    },
  },
    methods: {
    init() {
      // get value
      this.getData(this.from,this.to).then(
          response => {
            this.value = response[0][1];
          },
          error => {
            this.$store.dispatch('alert/error', error)
          }
      )
      // get value2 (insgesamt)
      this.getData(null,null).then(
          response => {
            this.value2 = response[0][1];
          },
          error => {
            this.$store.dispatch('alert/error', error)
          }
      )
    },
      getData(from, to) {
        return new Promise((resolve, reject) => {
          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          const requestOptions = {
            method: 'GET',
            headers: header
          };

          let url = process.env.VUE_APP_API_SERVER + `/stats/` + this.figures[this.figure].slug;
          url = url + `/` + this.customer.id;
          url = url + `/` + this.location.id;
          if (from !== null) url = url + `/` + from;
          if (to !== null) url = url + `/` + to;


          fetch(url, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                resolve(response);
              }, error => {
                reject(error);
              });
        });
      },
    }
  }

</script>